import { EntityInfo } from '../../../../api-service/clients/auto-generated-clients';

export function generateRelatedEntityUrl(entityInfo: EntityInfo | undefined): string {
  if (!entityInfo) return '';
  return `${window.location.origin}/gotoresource/${entityInfo.entityName}?resourceId=${entityInfo.entityId}`;
}
